"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsBsKvsStorageUtil = exports.CsBsKvsStorage = void 0;
var eventemitter3_1 = require("eventemitter3");
var dayjs_1 = __importDefault(require("dayjs"));
var timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(timezone_1.default);
dayjs_1.default.extend(utc_1.default);
var index_1 = require("../index");
/**
 * KVS登録を行った情報をWeb storage(localStoroge)を使って参照できるようにするためのクラス
 *
 * @class CsBsKvsStorage
 * @extends {EventEmitter}
 */
var CsBsKvsStorage = /** @class */ (function (_super) {
    __extends(CsBsKvsStorage, _super);
    function CsBsKvsStorage(key) {
        var _this = _super.call(this) || this;
        _this.key = key;
        window.addEventListener('storage', function (event) {
            // const oldValue = event.oldValue
            // const newValue = event.newValue
            // const storageArea = event.storageArea
            if (event.key == _this.key) {
                // データの変更を通知
                _this.emit('change');
            }
        });
        // コンソールを画面に表示
        if (CsBsKvsStorage.showConsole) {
            index_1.Console.init();
        }
        return _this;
    }
    /**
     * localStorage の機能検出
     *
     * @static
     * @return {*}  {boolean} localStorageが使用できるかどうか
     * @memberof CsBsKvsStorage
     */
    CsBsKvsStorage.storageAvailable = function () {
        if (CsBsKvsStorage._storageAvailable != undefined)
            return CsBsKvsStorage._storageAvailable;
        // Web Storage API の使用 localStorage の機能検出
        // https://developer.mozilla.org/ja/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
        var type = 'localStorage';
        var storage;
        try {
            storage = window[type];
            var x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            CsBsKvsStorage._storageAvailable = true;
            return true;
        }
        catch (e) {
            CsBsKvsStorage._storageAvailable = false;
            return false;
            // return (
            //   e instanceof DOMException &&
            //   // everything except Firefox
            //   (e.code === 22 ||
            //     // Firefox
            //     e.code === 1014 ||
            //     // test name field too, because code might not be present
            //     // everything except Firefox
            //     e.name === 'QuotaExceededError' ||
            //     // Firefox
            //     e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            //   // acknowledge QuotaExceededError only if there's something already stored
            //   storage &&
            //   storage.length !== 0
            // )
        }
    };
    /**
     * 登録を行います
     *
     * @memberof CsBsKvsStorage
     */
    CsBsKvsStorage.prototype.push = function (item) {
        if (CsBsKvsStorage.storageAvailable()) {
            var list = this.get();
            list = !list ? [] : list;
            //更新回数
            var updateCount = 0;
            // 重複削除
            var registedItem = list.find(function (x) { return x.app_id == item.app_id && x.data_name == item.data_name; });
            if (registedItem) {
                updateCount = registedItem.updateCount
                    ? registedItem.updateCount + 1
                    : 1;
                list.splice(list.indexOf(registedItem), 1);
            }
            // ユニークID（index）を計算
            var newIdIndex = 0;
            if (list.length) {
                var maxIdModel = list.reduce(function (a, b) {
                    return (!a.id ? 0 : a.id) > (!b.id ? 0 : b.id) ? a : b;
                });
                newIdIndex = !maxIdModel.id ? 1 : maxIdModel.id + 1;
            }
            item.id = newIdIndex;
            // 更新回数をセット
            item.updateCount = updateCount;
            // 時間を更新
            item.time = (0, dayjs_1.default)().tz('Asia/Tokyo').format();
            list.push(item);
            var dataString = JSON.stringify(list, undefined, 1);
            localStorage.setItem(this.key, dataString);
        }
    };
    /**
     * すべての登録を取得します。
     *
     * @memberof CsBsKvsStorage
     */
    CsBsKvsStorage.prototype.get = function () {
        if (CsBsKvsStorage.storageAvailable()) {
            var dataString = localStorage.getItem(this.key);
            var data = [];
            if (dataString) {
                data = JSON.parse(dataString);
            }
            return data;
        }
        return [];
    };
    /**
     * すべての登録を削除します
     *
     * @memberof CsBsKvsStorage
     */
    CsBsKvsStorage.prototype.delete = function (item) {
        var list = this.get();
        list = !list ? [] : list;
        // 探す
        var registedItem = list.find(function (x) { return x.app_id == item.app_id && x.data_name == item.data_name; });
        // 削除
        if (registedItem) {
            list.splice(list.indexOf(registedItem), 1);
        }
        // 保存
        var dataString = JSON.stringify(list, undefined, 1);
        localStorage.setItem(this.key, dataString);
    };
    /**
     * 新たなグループIDを返します
     *
     * @return {*}  {number}
     * @memberof CsBsKvsStorage
     */
    CsBsKvsStorage.prototype.getNewGroupId = function () {
        var list = this.get();
        list = !list ? [] : list;
        var newGroupId = 1;
        list.forEach(function (item) {
            if (item.groupId) {
                newGroupId = newGroupId < item.groupId ? newGroupId : item.groupId + 1;
            }
        });
        return newGroupId;
    };
    /**
     * すべての登録を削除します
     *
     * @memberof CsBsKvsStorage
     */
    CsBsKvsStorage.prototype.clear = function () {
        if (CsBsKvsStorage.storageAvailable()) {
            localStorage.removeItem(this.key);
            this.emit('change');
        }
    };
    // コンソール表示を行うかどうか
    CsBsKvsStorage.showConsole = true;
    //
    CsBsKvsStorage._storageAvailable = undefined;
    return CsBsKvsStorage;
}(eventemitter3_1.EventEmitter));
exports.CsBsKvsStorage = CsBsKvsStorage;
/**
 * CsBsKvsStorage用ユーティリティ
 *
 * @class CsBsKvsStorageUtil
 */
var CsBsKvsStorageUtil = /** @class */ (function () {
    function CsBsKvsStorageUtil() {
    }
    /**
     * 登録:key_valuesが複数の場合、個別に登録
     *
     * @static
     * @param {CsBsKvsStorage} storage
     * @param {CsBsKVSData} data
     * @param {boolean} apiRegist
     * @param {boolean} hasError
     * @memberof CsBsKvsStorageUtil
     */
    CsBsKvsStorageUtil.pushData = function (_a) {
        var storage = _a.storage, data = _a.data, groupId = _a.groupId, apiRegist = _a.apiRegist, hasError = _a.hasError;
        // key_valuesが複数の場合、個別に登録
        var keyValueCount = data.key_values.length;
        data.key_values.forEach(function (key_value) {
            // Objectを複製、個別のデータを作成
            var tmpItem = JSON.parse(JSON.stringify(data));
            delete tmpItem.key_values;
            tmpItem.key_values = [key_value];
            // 登録
            storage.push({
                app_id: data.app_id,
                data_name: key_value.data_name,
                payload: tmpItem,
                groupId: keyValueCount > 1 ? groupId : undefined,
                apiRegist: apiRegist,
                hasError: hasError,
            });
        });
    };
    return CsBsKvsStorageUtil;
}());
exports.CsBsKvsStorageUtil = CsBsKvsStorageUtil;
//# sourceMappingURL=CsBsKvsStorage.js.map